import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCharts from 'vue-charts'
import App from '@/App'
import router from '@/router'
import '@/filters'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import rollbarInitializer from '@/services/rollbar'
import 'materialize-css/dist/js/materialize'
// import './materialize'

rollbarInitializer()
sync(store, router)
Vue.store = store
Vue.router = router
Vue.use(VueAxios, axios)
Vue.use(VueCharts)

Vue.config.productionTip = false
document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
})



// WEBPACK FOOTER //
// ./src/main.js